const ExcludedDomain = ['hotmail', 'live', 'outlook', 'msn', 'gmail', 'yahoo'];

export const isValidCorporativeEmail = (email: string) => {
  // eslint-disable-next-line regexp/no-unused-capturing-group, @typescript-eslint/no-non-null-assertion
  const matchResult = email ? email.match(/@(\w+)/) : null;
  const domain = (matchResult && matchResult[1]) || '';
  return domain && ExcludedDomain.includes(domain) ? false : true;
};
